import { ViewModel,View, ObservableArray } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ISendPackageTab } from "../sendPackageDetail/sendPackageDetail-viewModel";
import  { SendPackageProductsView } from "./sendPackageProducts-view"

export class SendPackageProductsViewModel extends ViewModel implements ISendPackageTab {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.tabName = 'کالا ها';
        this.sendPackageProducts = ObservableArray.create<SendPackageProduct>();
    }
    GetDefaultView(): View <ViewModel> {
        return new SendPackageProductsView();
    }
    public getTypeId(): string {
        return "VM-178301EB-C33C-465C-B61B-93029C074C0E"
    }
    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set sendPackageProducts(v: ObservableArray<SendPackageProduct>) { this._sendPackageProducts = v; } public get sendPackageProducts(): ObservableArray<SendPackageProduct> { return this._sendPackageProducts; } private _sendPackageProducts: ObservableArray<SendPackageProduct>;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;

    public async load(sendPackageId) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllSendPackageItems', {
                SendPackageId: sendPackageId,
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            this.sendPackageId = sendPackageId;
            this.sendPackageProducts.update(...result.SendPackageItems.map((q, i) => {
                let r = new SendPackageProduct(this);
                r.rowNumber = i + 1;
                r.sendableCreatorName = q.SendableCreatorName;
                r.productCode = q.ProductCode;
                r.measuredProductId = q.MeasuredProductId;
                r.productCarModel = q.ProductCarModel;
                r.productName = q.ProductName;
                r.productUnit = q.ProductUnit;
                r.amount = q.Amount;
                r.orderAmount = q.OrderAmount;
                r.receiptAmount = q.ReceiptAmount;
                r.receiptComment = q.ReceiptComment;
                r.orderComment = q.OrderComment;
                r.warehouseLocation = q.WarehouseLocation;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this.isLoading = false;
        }
    }

}

export class SendPackageProduct extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendPackageProductsViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: SendPackageProductsViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set sendableCreatorName(v: string) { this._sendableCreatorName = v; } public get sendableCreatorName(): string { return this._sendableCreatorName;} private _sendableCreatorName: string;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment;} private _orderComment: string;
    public set orderAmount(v: number) { this._orderAmount = v; } public get orderAmount(): number { return this._orderAmount;} private _orderAmount: number;
    public set receiptAmount(v: number) { this._receiptAmount = v; } public get receiptAmount(): number { return this._receiptAmount;} private _receiptAmount: number;
    public set receiptComment(v: string) { this._receiptComment = v; } public get receiptComment(): string { return this._receiptComment;} private _receiptComment: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation;} private _warehouseLocation: string;
    
}

